import type { ButtonSection } from "@keepoinc/site-page-react-component";
import { useTranslation } from "react-i18next";

import Input from "../../../../components/Form/Input/input";
import { Form, FormGroup } from "../../../../components/Form/styles";
import { Box } from "../../../../components/Layout";
import SaveBar from "../../../../components/SaveBar";
import { SubHeader } from "../../../../components/SubHeader";
import { sanitizeUrl } from "../../../../utils/url";
import { PageLinkField, useLinkablePageId } from "../../components/PageLinkField";
import { useSection } from "../../hooks/Section";
import { Container } from "./styles";

export const ButtonPage = () => {
  const { t } = useTranslation();

  const { section, setSection, saveSection, hasUnsavedChanges } = useSection<ButtonSection & { pageId?: string }>(
    "button"
  );

  // a page of the Keepo (pageId) or an address (link); a page that's gone (or not PLUS) needs an address again
  const linkedPageId = useLinkablePageId(section.pageId);
  const isSaveDisabled = !section.text || (!linkedPageId && !section.link);

  const saveHandler = () => {
    saveSection({
      ...section,
      // with a page, the published page builds the link from it
      pageId: linkedPageId,
      link: linkedPageId ? "" : (sanitizeUrl(section.link) as string),
    });
  };

  return (
    <Container>
      <SubHeader
        title={t("pages.editor.button.header.title")}
        crumbs={[{ label: t("pages.editor.preview.footer.actions.sections"), to: "/editor/sections" }]}
        hasUnsavedChanges={hasUnsavedChanges}
      />
      <Form>
        <Box>
          <FormGroup>
            <Input
              id="buttonTitle"
              type="text"
              value={section.text}
              onChange={e =>
                setSection({
                  ...section,
                  text: e.target.value,
                })
              }
              required
              maxLength={65}
              label={t("pages.editor.button.form.buttonTitle")}
            />
          </FormGroup>
          <PageLinkField pageId={section.pageId} onChange={pageId => setSection({ ...section, pageId })} />
          {!linkedPageId && (
            <FormGroup>
              <Input
                autoCapitalize="none"
                id="buttonLink"
                type="text"
                value={section.link}
                required
                onChange={e =>
                  setSection({
                    ...section,
                    link: e.target.value,
                  })
                }
                label={t("pages.editor.button.form.buttonLink")}
              />
            </FormGroup>
          )}
        </Box>
        <SaveBar onSave={saveHandler} disabled={isSaveDisabled} hasUnsavedChanges={hasUnsavedChanges} />
      </Form>
    </Container>
  );
};
